import { useContext } from 'react'
import { AuthContext } from '@/context/auth-context'
import { useAppDispatch } from '@/store/store-hooks'
import { AuthDialogType, openAuthDialog, setMobileSidebarOpen } from '@/store/slices/ui-state.slice'
import { Button } from '@/components/button/Button'
import { IconButton } from '@/components/icon-button/IconButton'
import AccountIcon from '@/assets/icons/user-account.svg?react'

type SidebarItemAnonSignInProps = {
  /** Renders a single icon button for the contracted rail, since the two full buttons don't fit */
  contracted?: boolean
}

export default function SidebarItemAnonSignIn({ contracted = false }: SidebarItemAnonSignInProps) {
  const dispatch = useAppDispatch()

  // Auth Context
  const authContext = useContext(AuthContext)
  const { user } = authContext
  const userIsAnon = user?.isAnonymous

  // Only render for anonymous users
  if (!userIsAnon) {
    return null
  }

  // SidebarAccountMenu renders nothing for anonymous users, so the rail footer would be empty.
  if (contracted) {
    return (
      <IconButton
        aria-label="Sign up"
        icon={<AccountIcon />}
        onClick={() => {
          dispatch(openAuthDialog({ authDialogType: AuthDialogType.SIGN_UP }))
          dispatch(setMobileSidebarOpen(false))
        }}
        size="sm"
        tooltipText="Sign up"
        tooltipPlacement="right"
        variant="tonal"
      />
    )
  }

  return (
    <div className="p-4 flex flex-row gap-3 border-t">
      <Button
        fullWidth
        onClick={() => {
          dispatch(openAuthDialog({ authDialogType: AuthDialogType.SIGN_UP }))
          dispatch(setMobileSidebarOpen(false))
        }}
      >
        Sign up
      </Button>
      <Button
        variant="outlined"
        fullWidth
        onClick={() => {
          dispatch(openAuthDialog({ authDialogType: AuthDialogType.SIGN_IN }))
          dispatch(setMobileSidebarOpen(false))
        }}
      >
        Sign in
      </Button>
    </div>
  )
}
